import _regeneratorRuntime from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import axios from "axios";

var RentGapRequest =
/*#__PURE__*/
function () {
  function RentGapRequest() {
    _classCallCheck(this, RentGapRequest);
  }

  _createClass(RentGapRequest, [{
    key: "GetPropertyList",
    value: function () {
      var _GetPropertyList = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(userId) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", axios.get("/api/RentGapRequest/GetPropertyList/".concat(userId)));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function GetPropertyList(_x) {
        return _GetPropertyList.apply(this, arguments);
      }

      return GetPropertyList;
    }()
  }, {
    key: "GetRentGapByPropertyList",
    value: function () {
      var _GetRentGapByPropertyList = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(projectId) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", axios.get("/api/RentGapRequest/GetRentGapByPropertyList/".concat(projectId)));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function GetRentGapByPropertyList(_x2) {
        return _GetRentGapByPropertyList.apply(this, arguments);
      }

      return GetRentGapByPropertyList;
    }()
  }, {
    key: "GetRentGapPropertyInfo",
    value: function () {
      var _GetRentGapPropertyInfo = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(projectId, year) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", axios.get("/api/RentGapRequest/GetRentGapPropertyInfo/".concat(projectId, "/").concat(year)));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function GetRentGapPropertyInfo(_x3, _x4) {
        return _GetRentGapPropertyInfo.apply(this, arguments);
      }

      return GetRentGapPropertyInfo;
    }()
  }, {
    key: "IsPropertyQualified",
    value: function () {
      var _IsPropertyQualified = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(projectId) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", axios.get("/api/RentGapRequest/IsPropertyQualified/".concat(projectId)));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function IsPropertyQualified(_x5) {
        return _IsPropertyQualified.apply(this, arguments);
      }

      return IsPropertyQualified;
    }()
  }, {
    key: "GetRentGapRelatedNonCompliance",
    value: function () {
      var _GetRentGapRelatedNonCompliance = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(projectId) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", axios.get("/api/RentGapRequest/GetRentGapRelatedNonCompliance/".concat(projectId)));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function GetRentGapRelatedNonCompliance(_x6) {
        return _GetRentGapRelatedNonCompliance.apply(this, arguments);
      }

      return GetRentGapRelatedNonCompliance;
    }()
  }, {
    key: "CreateRentGapApplication",
    value: function () {
      var _CreateRentGapApplication = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6(projectId, year) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", axios.get("/api/RentGapRequest/CreateRentGapApplication/".concat(projectId, "/").concat(year)));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function CreateRentGapApplication(_x7, _x8) {
        return _CreateRentGapApplication.apply(this, arguments);
      }

      return CreateRentGapApplication;
    }()
  }, {
    key: "GetProjectHasHardDebtValueByYear",
    value: function () {
      var _GetProjectHasHardDebtValueByYear = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7(year, projectId) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", axios.get("/api/RentGapRequest/GetProjectHasHardDebtValueByYear/".concat(year, "/").concat(projectId)));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function GetProjectHasHardDebtValueByYear(_x9, _x10) {
        return _GetProjectHasHardDebtValueByYear.apply(this, arguments);
      }

      return GetProjectHasHardDebtValueByYear;
    }()
  }, {
    key: "GetLastYearsRentGap",
    value: function () {
      var _GetLastYearsRentGap = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8(year, projectId) {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt("return", axios.get("/api/RentGapRequest/GetLastYearsRentGap/".concat(year, "/").concat(projectId)));

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      function GetLastYearsRentGap(_x11, _x12) {
        return _GetLastYearsRentGap.apply(this, arguments);
      }

      return GetLastYearsRentGap;
    }()
  }, {
    key: "HasValidExhibitJ",
    value: function () {
      var _HasValidExhibitJ = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9(projectId) {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                return _context9.abrupt("return", axios.get("/api/RentGapRequest/HasValidExhibitJ/".concat(projectId)));

              case 1:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      function HasValidExhibitJ(_x13) {
        return _HasValidExhibitJ.apply(this, arguments);
      }

      return HasValidExhibitJ;
    }()
  }, {
    key: "GetRequestItemsByHeaderId",
    value: function () {
      var _GetRequestItemsByHeaderId = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee10(rentGapRequestHeaderId) {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                return _context10.abrupt("return", axios.get("/api/RentGapRequest/GetRequestItemsByHeaderId/".concat(rentGapRequestHeaderId)));

              case 1:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));

      function GetRequestItemsByHeaderId(_x14) {
        return _GetRequestItemsByHeaderId.apply(this, arguments);
      }

      return GetRequestItemsByHeaderId;
    }()
  }, {
    key: "GetRentGapRequestReview",
    value: function () {
      var _GetRentGapRequestReview = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee11(Id) {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                return _context11.abrupt("return", axios.get("/api/RentGapRequest/GetRentGapRequestReview/".concat(Id)));

              case 1:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }));

      function GetRentGapRequestReview(_x15) {
        return _GetRentGapRequestReview.apply(this, arguments);
      }

      return GetRentGapRequestReview;
    }()
  }, {
    key: "SendSubmittedEmail",
    value: function () {
      var _SendSubmittedEmail = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee12(rentGapRequestHeaderId) {
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                return _context12.abrupt("return", axios.post("/api/RentGapRequest/SendSubmittedEmail/".concat(rentGapRequestHeaderId)));

              case 1:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }));

      function SendSubmittedEmail(_x16) {
        return _SendSubmittedEmail.apply(this, arguments);
      }

      return SendSubmittedEmail;
    }()
  }, {
    key: "SendDeniedEmail",
    value: function () {
      var _SendDeniedEmail = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee13(rentGapRequestHeaderId) {
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                return _context13.abrupt("return", axios.post("/api/RentGapRequest/SendDeniedEmail/".concat(rentGapRequestHeaderId)));

              case 1:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13);
      }));

      function SendDeniedEmail(_x17) {
        return _SendDeniedEmail.apply(this, arguments);
      }

      return SendDeniedEmail;
    }()
  }, {
    key: "SendApprovalEmail",
    value: function () {
      var _SendApprovalEmail = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee14(rentGapRequestHeaderId) {
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                return _context14.abrupt("return", axios.post("/api/RentGapRequest/SendApprovalEmail/".concat(rentGapRequestHeaderId)));

              case 1:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14);
      }));

      function SendApprovalEmail(_x18) {
        return _SendApprovalEmail.apply(this, arguments);
      }

      return SendApprovalEmail;
    }()
  }, {
    key: "SendBackToPropertyEmail",
    value: function () {
      var _SendBackToPropertyEmail = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee15(rentGapRequestHeaderId) {
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                return _context15.abrupt("return", axios.post("/api/RentGapRequest/SendBackToPropertyEmail/".concat(rentGapRequestHeaderId)));

              case 1:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15);
      }));

      function SendBackToPropertyEmail(_x19) {
        return _SendBackToPropertyEmail.apply(this, arguments);
      }

      return SendBackToPropertyEmail;
    }()
  }, {
    key: "GetRentGapList",
    value: function () {
      var _GetRentGapList = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee16(year, statusId) {
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                return _context16.abrupt("return", axios.get("/api/RentGapRequest/GetRentGapList", {
                  params: {
                    year: year,
                    statusId: statusId
                  }
                }));

              case 1:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16);
      }));

      function GetRentGapList(_x20, _x21) {
        return _GetRentGapList.apply(this, arguments);
      }

      return GetRentGapList;
    }()
  }, {
    key: "GetAdjustedResubmitDate",
    value: function () {
      var _GetAdjustedResubmitDate = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee17(date) {
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                return _context17.abrupt("return", axios.get("/api/RentGapRequest/GetAdjustedResubmitDate", {
                  params: {
                    date: date
                  }
                }));

              case 1:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17);
      }));

      function GetAdjustedResubmitDate(_x22) {
        return _GetAdjustedResubmitDate.apply(this, arguments);
      }

      return GetAdjustedResubmitDate;
    }()
  }, {
    key: "UploadFile",
    value: function () {
      var _UploadFile = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee18(files, projectId, requestId, fileName) {
        var formData;
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                formData = new FormData();
                files.forEach(function (file) {
                  formData.append("files[]", file);
                });
                formData.append("projectId", projectId);
                formData.append("requestId", requestId);
                formData.append("fileName", fileName);
                formData.append("documentType", "test");
                return _context18.abrupt("return", axios.post("/api/FileUpload", formData, {
                  headers: {
                    "Content-Type": "multipart/form-data"
                  }
                }));

              case 7:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18);
      }));

      function UploadFile(_x23, _x24, _x25, _x26) {
        return _UploadFile.apply(this, arguments);
      }

      return UploadFile;
    }()
  }, {
    key: "GetMaxRentsByYear",
    value: function () {
      var _GetMaxRentsByYear = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee19(year) {
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                return _context19.abrupt("return", axios.get("/api/RentGapRequest/GetMaxRentsByYear/".concat(year)));

              case 1:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19);
      }));

      function GetMaxRentsByYear(_x27) {
        return _GetMaxRentsByYear.apply(this, arguments);
      }

      return GetMaxRentsByYear;
    }()
  }, {
    key: "GetMaxRentsTableByYear",
    value: function () {
      var _GetMaxRentsTableByYear = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee20(year) {
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                return _context20.abrupt("return", axios.get("/api/RentGapRequest/GetMaxRentsTableByYear/".concat(year)));

              case 1:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20);
      }));

      function GetMaxRentsTableByYear(_x28) {
        return _GetMaxRentsTableByYear.apply(this, arguments);
      }

      return GetMaxRentsTableByYear;
    }()
  }, {
    key: "CreatePdf",
    value: function () {
      var _CreatePdf = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee21(projectId, year, headerId) {
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                return _context21.abrupt("return", axios.get("/api/RentGapRequest/CreatePdf/".concat(projectId, "/").concat(year, "/").concat(headerId), {
                  responseType: "blob"
                }));

              case 1:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21);
      }));

      function CreatePdf(_x29, _x30, _x31) {
        return _CreatePdf.apply(this, arguments);
      }

      return CreatePdf;
    }()
  }]);

  return RentGapRequest;
}();

export default new RentGapRequest();